import React, { useState } from 'react'
import {
    Box,
    CircularProgress,
    Grid,
    Card,
    Link,
    Dialog,
    DialogTitle,
    CardActions,
    CardMedia,
    CardActionArea,
    CardContent,
    Typography,
    makeStyles,
    useTheme,
    useMediaQuery,
    alpha,
} from '@material-ui/core';
import { redirect } from "react-router-dom";

import ComponentWrapper from '../../../components/common/ComponentWrapper';
import { StyledTextFieldForm, CustomTinyButton } from '../../common/CustomComponents'
import {
    EMAIL_ADDRESS,
    MORTAGE_MONSTER,
    OLD_CALCULATOR_LINK,
} from '../../../constants';
import { sendMail } from '../../../core/API';

import { InIcon, EmailIcon } from '../../../utils/icons';

import headerContact from '../../../assets/articles/contact.jpg';
import ClassicImage from '../../../assets/articles/classic.jpg';
import MortgageMonsterImage from '../../../assets/articles/mortgagemonster.jpg';

const useStyles = makeStyles((theme) => {

    return {
        contentWrapper: {
            padding: 20,
        },

        media: {
            height: 140,
            position: "relative",
            backgroundColor: "transaprent",
        },

        media_bg: {
            height: 140,
            width: '100%',
            background: `linear-gradient(${theme.palette.tertiary.light}, ${theme.palette.primary.main})`,
            opacity: 0.5,
            position: "absolute",
            top: 0,
            left: 0,
            '&:hover': {
                opacity: 0.0,
            }
        },

        media_title: {
            height: 140,
            width: '100%',
            position: "absolute",
            top: 0,
            left: 0,
        },

        media_title_text: {
            paddingTop: 10,
            paddingBottom: 10,
            textAlign: 'center',
            color: '#FAFAFA',
            backgroundColor: theme.palette.primary.main,
            textTransform: "uppercase",
        },

        contentHeader: {
            height: 400,
        },

        underline: {
            height: 1,
            backgroundColor: theme.palette.primary.contrastText,
            opacity: 0.25,
            margin: '5px 0px 0 0',
        },


        infoCard: {
            position: 'relative',
            borderRadius: 0,
            height: '100%',
            //backgroundColor: theme.palette.background.default,
            //background: `linear-gradient(${theme.palette.background.paper}, ${theme.palette.background.default})`,
            backgroundColor: theme.palette.background.paper,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            boxShadow: 'none',

        },


        card: {
            position: 'relative',
            borderRadius: 8,
            height: '100%',
            //backgroundColor: theme.palette.background.default,
            //background: `linear-gradient(${theme.palette.background.paper}, ${theme.palette.background.default})`,
            backgroundColor: alpha(theme.palette.background.default, 0.5),
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        },

        cardContent: {
            paddingBottom: 0,
        }
    }
});


export const MoreInfo = () => {
    const classes = useStyles();
    const theme = useTheme();
    const small = useMediaQuery(theme.breakpoints.down('sm'));
    const paddingStyle = { paddingTop: 20, paddingBottom: 20, paddingLeft: small ? 0 : 15, paddingRight: small ? 0 : 20 };


    const [open, setOpen] = React.useState(false);


    // const handleEmail = () => {
    //     const link = `${EMAIL_ADDRESS}`
    //     // window.open(link, "_blank");
    //     handleEmail(link)

    // }

    const handleClose = (value) => {
        setOpen(false);
    };



    const articles = [
        {
            image: ClassicImage,
            heading: "Classic PayCalculator",
            title: 'Prefer the old site?',
            body() {
                return (
                    <>This site has been updated in order to create an interface with more features, and a more maintainable codebase. The redesign will also provide a foundation for new iOS and Android apps.<br />If you prefer the original site, that's fine, it's still available.</>
                )
            },
            linkTitle: 'Original Site',
            linkBlankOption: true,
            link: OLD_CALCULATOR_LINK,
            linkIcon: <InIcon />,
        },
        {
            image: MortgageMonsterImage,
            heading: "Mortgage.Monster",
            title: 'Tame the mortgage beast',
            body() {
                return (
                    <> Manage your home loan repayments and tame the Mortgage Beast!<br />See how changes in mortgage interest rates and property prices will affect your repayments and cost of ownership over the life of your loan.</>
                )
            },
            linkTitle: 'www.mortgage.monster',
            linkBlankOption: true,
            link: MORTAGE_MONSTER,
            linkIcon: <InIcon />,
        },
        {
            image: headerContact,
            heading: "Contact Us",
            title: 'How can I contact the developer of paycalculator?',
            body() {
                return (
                    <>If you have a question about the calculations, if you have found a bug or if you have a useful suggestion please get in touch. Use the link below to send me an email.</>
                )
            },
            link: EMAIL_ADDRESS,
            linkTitle: 'Contact us',
            linkBlankOption: true,
            linkIcon: <EmailIcon />,
            // onClick: handleEmail
        },
    ]

    return (
        <ComponentWrapper minimal>
            <div className={classes.contentWrapper} style={paddingStyle} >
                <Grid container style={{ justifyContent: "center" }}>
                    {articles.map(data => {
                        return (
                            <Grid style={{padding:10}} item sm={12} md={6} lg={4} xl={3} key={data.title}>
                                <ArticleComponent {...data} />
                            </Grid>
                        )
                    })}

                </Grid>
            </div>
            <EmailDialog open={open} onClose={handleClose} />
        </ComponentWrapper>
    )
}


const ArticleComponent = (props) => {
    const classes = useStyles();

    const { onClick } = props;
    const onClickFn = onClick ? onClick : () => {
        
        let url = props.link;
        let blank = props.linkBlankOption;

        if (blank) {
            window.open(url, "_blank");
        } else {
            redirect(url)
        }
    }
        
        //onRedirect(props.link, props.linkBlankOption)}

    return (
        <Card className={classes.card} onClick={onClickFn}>
            <CardActionArea>
                {/* <Box className={classes.media_bg} /> */}
                <CardMedia
                    className={classes.media}
                    image={props.image}
                    title={props.title}
                />
                <Box className={classes.media_title} >
                    <Typography variant="h1" className={classes.media_title_text}>{props.heading}</Typography>
                </Box>
                <CardContent>
                    <Typography gutterBottom variant="h2" style={{ letterSpacing: "-0.5px" }}>
                        {props.title}
                    </Typography>
                    <Typography variant="body1">
                        {props.body()}
                    </Typography>
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Link>
                    <Box href={MORTAGE_MONSTER} aria-label={props.linkTitle} rel="noopener noreferrer" target="_blank"  display="flex" flexDirection="row" alignItems="center">
                        <Typography variant="h3"> {props.linkIcon}</Typography>
                        <div style={{ width: 5 }} />
                        <Typography variant="h3" style={{ paddingBottom: 5 }}> {props.linkTitle}</Typography>
                    </Box>
                </Link>
            </CardActions>
        </Card>
    )
}

const EmailDialog = (props) => {

    const { onClose, open } = props;
    const theme = useTheme();
    const defaultValidation = { name: true, address: true, message: true, ready: false };

    const [sending, setSending] = useState(false)

    const [touched, setTouched] = useState({ name: false, address: false, message: false })
    const [inputState, setInputs] = useState({ name: '', address: '', message: '' })
    const [validationState, setValidation] = useState({ ...defaultValidation })



    const updateInputs = (data) => {
        setInputs({ ...inputState, ...data })
        setTouched({...touched, ...data})
    }


    // const checkValidation = () => {
    //     let validate = { ...validationState };
    //     if (touched.name === false || touched.address === false || touched.message === false) {
    //         validate = { ...defaultValidation }
    //         setValidation(validate);
    //         return false;
    //     }

    //     validate.name = inputState.name !== ''
    //     validate.address = inputState.address !== ''
    //     validate.message = inputState.message !== ''
    //     validate.ready = (validate.name !== '' && validate.address!== '' && validate.message!== '' );
    //     setValidation(validate);
    //     return true

    // }
    // useEffect(() => { checkValidation() }, [ touched, inputState])
    
    const handleSend = async() => {

        setSending(true);
        sendMail(inputState).then((data) => {
            setValidation({ ...defaultValidation });
            if(data.toString().toLowerCase() === "success"){
                onClose();
                setInputs({ ...inputState, ready:false, message:'' })
                setSending(false);
            }else{
                setSending(false);
            }  

          })
    };

    const handleOpenApp = () => {
        const link = `${EMAIL_ADDRESS}?body=${inputState.message}`
        window.open(link, "_blank");
        onClose();
    }

    const handleClose = () => {
        onClose();
    };


    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
            <DialogTitle id="simple-dialog-title">{sending ? 'Sending':'Contact Us' }</DialogTitle>

            { sending ? (
                <Box display="flex" alignItems="center" justifyContent="center" style={{padding:60}}>
                <CircularProgress />
                </Box>
            ):(
                <Box style={{ padding: 20, paddingTop: 0 }}>
                <Box display="flex" justifyContent="flex-end" style={{ marginTop: -40 }}>
                    <CustomTinyButton
                        variant="contained"
                        style={{ backgroundColor: theme.palette.primary.light, width: 100 }}
                        onClick={handleOpenApp}
                    >
                        SEND FROM EMAIL APP
                    </CustomTinyButton>
                </Box>
                <form>
                    <StyledTextFieldForm
                        style={{ paddingBottom: 10, marginTop: 30 }}
                        label="NAME"
                        error={!validationState.name}
                        value={inputState.name}
                        fullWidth
                        placeholder={"name"}
                        variant="filled"
                        type="text"
                        id="emailName"
                        onChange={(event) => updateInputs({name: event.target.value })}
                        // onBlur={checkValidation}
                    />
                    <StyledTextFieldForm
                        style={{ paddingBottom: 10 }}
                        label="EMAIL ADDRESS"
                        error={!validationState.address}
                        value={inputState.address}
                        fullWidth
                        placeholder={"email"}
                        variant="filled"
                        type="text"
                        id="emailAddress"
                        onChange={(event) => updateInputs({address: event.target.value })}
                        //onBlur={checkValidation}
                    />
                    <StyledTextFieldForm
                        multiline
                        maxRows={4}
                        minRows={4}
                        label="MESSAGE"
                        error={!validationState.message}
                        value={inputState.message}
                        fullWidth
                        placeholder={""}
                        variant="filled"
                        type="text"
                        id="emailMessage"
                        onChange={(event) => updateInputs({message: event.target.value })}
                        // onBlur={checkValidation}
                    />
                </form>
                <Box display="flex" justifyContent="space-between" style={{ paddingTop: 20 }}>
                    <CustomTinyButton
                        disabled={!validationState.ready}
                        variant="contained"
                        style={{ backgroundColor: theme.palette.primary.light }}
                        onClick={handleSend}
                    >
                        SEND
                    </CustomTinyButton>
                    <CustomTinyButton
                        variant="contained"
                        style={{ backgroundColor: theme.palette.background.paper }}
                        onClick={handleClose}
                    >
                        CLOSE
                    </CustomTinyButton>

                </Box>
            </Box>

            )}

        </Dialog>
    )
}

export default MoreInfo